import { render, staticRenderFns } from "./ifmgrade.vue?vue&type=template&id=19751f14&scoped=true"
import script from "./ifmgrade.vue?vue&type=script&lang=js"
export * from "./ifmgrade.vue?vue&type=script&lang=js"
import style0 from "./ifmgrade.vue?vue&type=style&index=0&id=19751f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19751f14",
  null
  
)

export default component.exports